export const shellCard =
	'rounded-2xl border border-border/80 bg-card/95 shadow-sm shadow-black/5 backdrop-blur-sm'

export const chartPanel =
	'min-w-0 overflow-hidden rounded-xl border border-border/60 bg-secondary/20 p-4'

export const chartTheme = {
	foreColor: 'hsl(var(--muted-foreground))',
	borderColor: 'hsl(var(--border))',
}

export const baseChartOptions = {
	fontFamily: 'inherit',
	background: 'transparent',
	toolbar: { show: false },
	zoom: { enabled: false },
	width: '100%',
	redrawOnParentResize: true,
	parentHeightOffset: 0,
}

export function denseDateAxisLabels(dayCount: number) {
	const crowded = dayCount > 14
	return {
		style: { colors: chartTheme.foreColor, fontSize: '11px', fontWeight: 500 },
		datetimeUTC: false,
		format: 'dd MMM',
		hideOverlappingLabels: true,
		trim: true,
		rotate: crowded ? -45 : 0,
		rotateAlways: crowded,
		maxHeight: crowded ? 72 : 40,
	}
}

/** Adds horizontal padding so first/last points stay inside the plot area. */
export function chartDatetimeRangePadding(xValues: number[], rightRatio = 0.05, leftRatio = 0.01) {
	if (xValues.length === 0) return {}
	const minX = xValues[0]!
	const maxX = xValues[xValues.length - 1]!
	const span = Math.max(maxX - minX, 86_400_000)
	return {
		min: minX - span * leftRatio,
		max: maxX + span * rightRatio,
	}
}

export const STATUS_COLORS = {
	Succeeded: '#1ed27d',
	Failed: '#ef4444',
	Pending: '#f59e0b',
	Refunded: '#94a3b8',
	Trial: '#38bdf8',
	Paid: '#1ed27d',
	Active: '#1ed27d',
	Inactive: '#8b5cf6',
	Expired: '#ef4444',
}
